export const PARTICIPANT_SEARCH_SCOPES_OPTIONS = {
  Name: "participant.name",
  "One Liner": "participant.oneLiner",
  Email: "participant.email",
} as const;
export const OTHER_SCOPES_OPTIONS = {
  Resume: "resume.content",
  Application: "application.content",
  Reference: "reference.content",
  "Action Item": "actionItem.content",
} as const;

export const ALL_SCOPE_OPTIONS = {
  ...PARTICIPANT_SEARCH_SCOPES_OPTIONS,
  ...OTHER_SCOPES_OPTIONS,
} as const;
export const RANKS = ["Low", "Medium", "High"] as const;
